export default {
    // 更新loading状态
    uppdateIsLoading(state, payload) {
        state.isLoading = payload
    },
    uppdateNavMenuActive(state, payload) {
        state.NavMenuActive = payload
    },
    // 更新登录的userinfo信息
    updateUserInfo (state, payload) {
        state.userInfo = payload
    },
    // 更新登陆返回的企业信息
    updateCorporationInfo(state, payload) {
        state.corporationInfo = payload
    },
    updateIs404(state, payload) {
        state.is404 = payload
    },
    // 更新企业列表
    updateCompanyList(state, payload) {
        state.companyList = payload
    },
    // 是否显示切换企业的弹框
    updateCompanyModal(state, payload) {
        state.isCompanyModal = payload
    },
    updataIsFlag(state,payload){
        state.isFlag = payload
    },
    upNewUser(state,payload){
        state.newUser = payload
    }
    
}
